import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        if (user.temPermissao(['admin_produtos'])) {
            can('manage', 'Produto')
        }
        if (user.temPermissao(['editor_produto'])) {
            can(['read', 'update'], 'Produto')
        }
        if (user.temPermissao(['produto'])) {
            can(['read'], 'Produto')
        }

        if (user.temPermissao(['taf'])) {
            can(['read'], 'TAF')
        }
        if (user.temPermissao(['editor_taf'])) {
            can(['read', 'update'], 'TAF')
        }
        if (user.temPermissao(['admin_taf'])) {
            can('manage', 'TAF')
        }

    }

    return build()
}